import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useConfiguratorState } from '../store';
import { BackLink, formatCurrency } from '../common';
import { usePricing, VehicleSpecPanelSummary } from './VehicleSpecPanel';
import { LeasingQuotationHost } from './LeasingQuotation';
import styles from './Summary.module.scss';

function SummaryPricingPanel({
	listPriceVat,
	optionalsTotalVat,
	totalVat,
	backToCustomizer,
}: {
	listPriceVat: number;
	optionalsTotalVat: number;
	totalVat: number;
	backToCustomizer: () => void;
}) {
	const { t } = useTranslation();

	return (
		<div>
			<BackLink onClick={backToCustomizer}>
				{t('car_configurator_summary_back_link', {
					defaultValue: 'Torna alla personalizzazione',
				})}
			</BackLink>

			<h1 className={styles.heading}>
				{t('car_configurator_end_heading', {
					defaultValue: 'Quotazione noleggio',
				})}
			</h1>

			<div className={styles.pricingCard}>
				<div className={styles.pricingCardHeader}>
					{t('car_configurator_light_summary_price_recap_header', {
						defaultValue: 'Configura il noleggio',
					})}
				</div>
				<div className={styles.pricingCardBody}>
					<div className={styles.priceRow}>
						<span>
							{t('car_configurator_summary_list_price_label', {
								defaultValue: 'Prezzo di listino',
							})}
						</span>
						<span>{formatCurrency(listPriceVat)}</span>
					</div>

					{optionalsTotalVat > 0 && (
						<div className={styles.priceRow}>
							<span>
								{t('car_configurator_summary_optionals_total_label', {
									defaultValue: 'Totale optional',
								})}
							</span>
							<span>+ {formatCurrency(optionalsTotalVat)}</span>
						</div>
					)}

					<div className={styles.totalRow}>
						<span>
							{t('car_configurator_summary_vehicle_total_label', {
								defaultValue: 'Totale veicolo',
							})}
						</span>
						<span>{formatCurrency(totalVat)}</span>
					</div>
					<span className={styles.vatLabel}>
						{t('car_configurator_customizer_vat_excluded', {
							defaultValue: 'IVA Esclusa',
						})}
					</span>

					{process.env.REACT_APP_QUICKO_ENABLED === '1' && (
						<LeasingQuotationHost />
					)}
				</div>
			</div>
		</div>
	);
}

export function SummaryPage() {
	const pricing = usePricing();
	const backToCustomizer = useConfiguratorState((s) => s.backToCustomizer);

	return (
		<section className={styles.page}>
			<Row className="g-4">
				<Col lg={8}>
					<SummaryPricingPanel
						listPriceVat={pricing.listPriceVat}
						optionalsTotalVat={pricing.optionalsTotalVat}
						totalVat={pricing.totalVat}
						backToCustomizer={backToCustomizer}
					/>
				</Col>
				<Col lg={4}>
					<VehicleSpecPanelSummary />
				</Col>
			</Row>
		</section>
	);
}
